import { Button, Css, ModalBody, ModalFooter, ModalHeader, useModal, useSnackbar } from "@homebound/beam";
import { ProjectsForLotSequenceFragment } from "src/fragments/circularFragments.generated";
import { DevelopmentProjectDetailFragment } from "src/routes/developments/DevelopmentAllLots.generated";
import { CohortDevelopmentDetailsFragment } from "src/routes/developments/lot-summary/sequence-sheet/components/move-project-button-menu/MoveProjectButtonMenu.generated";
import { useUpdateProjectCohortMutation } from "src/routes/developments/lot-summary/sequence-sheet/components/move-project-modal/MoveProjectModal.generated";
type MoveModalProps = {
  cohortDevelopment: CohortDevelopmentDetailsFragment;
  project: ProjectsForLotSequenceFragment | DevelopmentProjectDetailFragment;
};

export function MoveProjectModal({ cohortDevelopment, project }: MoveModalProps) {
  const { closeModal } = useModal();
  const { name: projectName, cohort } = project;
  const { id: cohortId, name: cohortName, development } = cohortDevelopment;
  const [updateProjectCohort] = useUpdateProjectCohortMutation();
  const { triggerNotice } = useSnackbar();

  // If we're moving a project to a cohort within the same development, then our PRPC will not be reset
  const willResetConfig = development?.id !== cohort?.development?.id;

  async function onSubmit() {
    await updateProjectCohort({
      variables: { input: { id: project.id, cohortId } },
      update: (cache, { data }) => {
        // Update the project's cohort in the cache
        cache.modify({
          id: cache.identify(project),
          fields: {
            cohort() {
              return data?.saveProject?.project.id ?? null;
            },
          },
        });
      },
    });
    closeModal();
    triggerNotice({ message: `Project ${projectName} moved to ${development?.name}`, icon: "success" });
  }

  return (
    <>
      <ModalHeader>Are you sure you want to move this project?</ModalHeader>
      <ModalBody>
        You're moving
        <span css={Css.smSb.$}> {projectName} </span>
        from
        <span css={Css.smSb.$}> {cohort?.development?.name}</span>
        <span css={Css.smSb.$}> - {cohort?.name} </span>
        to
        <span css={Css.smSb.$}> {development?.name}</span>
        <span css={Css.smSb.$}> - {cohortName}. </span>
        {willResetConfig && <span>This will reset the project configuration. </span>}
        Are you sure you want to continue?
      </ModalBody>
      <ModalFooter>
        <Button variant="quaternary" label="Cancel" onClick={() => closeModal()} />
        <Button label="Move project" onClick={onSubmit} />
      </ModalFooter>
    </>
  );
}
